module.exports = "/static/assets/5b1a4d196ba87f7bcf2f697b5daf51b9.png";